import { memo } from 'react';
import { useSelector } from 'react-redux';
import { useIsLoggedIn } from 'shared/hooks/useIsLoggedIn';
import { State } from 'shared/interface';
import { BannerData } from 'shared/types/cms';
import { BannerSlider } from './components/BannerSlider';
import { BannerSquare } from './components/BannerSquare';
export const Banner = memo(() => {
	const bannerData = useSelector<State, BannerData[]>((state) => state.home.bannerData);
	const isLoggedIn = useIsLoggedIn();
	if (!isLoggedIn) return <BannerSquare banner={bannerData?.[0]} />;

	return <BannerSlider banner={bannerData} />;
});
